import { render, staticRenderFns } from "./orgHeader.vue?vue&type=template&id=05d5531a&"
import script from "./orgHeader.vue?vue&type=script&lang=js&"
export * from "./orgHeader.vue?vue&type=script&lang=js&"
import style0 from "./orgHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports